import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { batchToggleFeatureSuccess, disableFeatureSuccess, enableFeatureSuccess, getAllAvailableFeatures, getAllFeatures, invokeAllAvailableFeatures, invokeAllFeatures, invokeBatchToggleFeature, invokeDisableFeature, invokeEnableFeature } from "./features.actions";
import { catchError, map, mergeMap, of } from "rxjs";
import { FeaturesService } from "src/app/shared/services/features.service";
import { setAPIStatus } from "../apiState.interface";
import { UserFeatureDto } from "src/app/shared/models/features/user-feature-dto.interface";
import { ToggleFeatureDto } from "src/app/shared/models/features/toggle-feature-dto.interface";
import { SuccessDto } from "src/app/shared/models/success-dto";
import { AvailableFeaturesDto } from "src/app/shared/models/features/available-feature-dto.interface";

@Injectable()
export class FeaturesEffect {
  constructor(
    private actions$: Actions,
    private featuresService: FeaturesService
  ) {}

  invokeGetAllFeatures$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invokeAllFeatures),
      mergeMap((state) => {
        return this.featuresService.getAllFeatures(state.email).pipe(
          map((data: UserFeatureDto[] | null) =>
            getAllFeatures({ features: data })
          ),
          catchError((error) =>
            of(
              setAPIStatus({
                apiStatus: {
                  apiResponseMessage: error,
                  apiStatus: "error",
                },
              })
            )
          )
        );
      })
    )
  );

  invokeGetAllAvailableFeatures$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invokeAllAvailableFeatures),
      mergeMap((state) => {
        return this.featuresService.getAllAvailableFeatures().pipe(
          map((data: AvailableFeaturesDto[] | null) =>
            getAllAvailableFeatures({ availableFeatures: data })
          ),
          catchError((error) =>
            of(
              setAPIStatus({
                apiStatus: {
                  apiResponseMessage: error,
                  apiStatus: "error",
                },
              })
            )
          )
        );
      })
    )
  );

  invokeEnableFeature$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invokeEnableFeature),
      mergeMap((state) => {
        return this.featuresService.enableFeature(state.payload).pipe(
          map((data: SuccessDto) =>
            enableFeatureSuccess({ success: data })
          ),
          catchError((error) =>
            of(
              setAPIStatus({
                apiStatus: {
                  apiResponseMessage: error,
                  apiStatus: "error",
                },
              })
            )
          )
        );
      })
    )
  );

  invokeDisableFeature$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invokeDisableFeature),
      mergeMap((state) => {
        return this.featuresService.disableFeature(state.payload).pipe(
          map((data: SuccessDto) =>
            disableFeatureSuccess({ success: data })
          ),
          catchError((error) =>
            of(
              setAPIStatus({
                apiStatus: {
                  apiResponseMessage: error,
                  apiStatus: "error",
                },
              })
            )
          )
        );
      })
    )
  );

  invokeBatchToggleFeature$ = createEffect(() =>
    this.actions$.pipe(
      ofType(invokeBatchToggleFeature),
      mergeMap((state) => {
        return this.featuresService.batchToggleFeatures(state.payload).pipe(
          map((data: SuccessDto) =>
            batchToggleFeatureSuccess({ success: data })
          ),
          catchError((error) =>
            of(
              setAPIStatus({
                apiStatus: {
                  apiResponseMessage: error,
                  apiStatus: "error",
                },
              })
            )
          )
        );
      })
    )
  );
}
